import { init, data, tag } from '@blotoutio/edgetag-sdk-js'
import googleAnalytics4 from '@blotoutio/providers-google-analytics-4-sdk'
import googleAdsClicks from '@blotoutio/providers-google-ads-clicks-sdk'
import bing from '@blotoutio/providers-bing-sdk'
import appLovin from '@blotoutio/providers-app-lovin-sdk'

export default ({ $config, store }, inject) => {
  init({
    edgeURL: $config.blotoutUrl,
    disableConsentCheck: true,
    providers: [googleAnalytics4, googleAdsClicks, bing, appLovin]
  })
  inject('blotout', {
    sendEvent: (name, opts) => {
      const splitTestVariant =
        store.getters['split-testing/splitTestFunnel'] || null
      tag(name, { ...(opts || {}), splitTestVariant })
    },
    sendUserData: (opts = {}) => {
      opts.phone = '+1' + opts.phone.replace(/[^\d]/g, '')
      data(opts)
    }
  })
}
